import { React, UseState, UseEffect } from 'react';
import { useTranslation } from 'react-i18next';
import PageContent from 'layouts/PageContent';
import InventoryFollowUpScreenDash from './InventoryFollowUpScreenDash';

const InventoryFollowUpScreen = (props) => {
  const {t, i18n} = useTranslation(['salesPerformance', 'common']);
  
  return (
    <PageContent title={t('salesPerformance:InventoryFollowUpDashboard')}>
      <InventoryFollowUpScreenDash />
    </PageContent>
  )
}

export default InventoryFollowUpScreen;